require('../scss/main.scss');



//////////////////
// WEBPACK FOOTER
// ../src/js/entry.js
// module id = 0
// module chunks = 1